import type { FC } from "react";
import styled from "styled-components";

import { FontSize, FontWeight } from "src/theme";
import { formatIfTime } from "src/utils";
import { Flex } from "../Layouts";
import { Text } from "../Text";

type InfoRowProps = {
    title: string;
    data: string;
};

export const InfoRow: FC<InfoRowProps> = ({ title, data }) => (
    <Flex>
        <StyledTitle>
            <Text wordBreak="normal" size={FontSize._14}>
                {title}:&nbsp;
            </Text>
        </StyledTitle>
        <div>
            <Text size={FontSize._14} weight={FontWeight._700}>
                {formatIfTime(data)}
            </Text>
        </div>
    </Flex>
);

const StyledTitle = styled.div`
    width: 120px;
`;
